/**
 * Input Schema of Sistema
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'

/* TODO: review generated schema */
export class InputSistemaSchema extends Schema {
  readonly name = 'InputSistema'

  readonly fieldSet: FieldSet<Sistema> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
